import fetchJobs from "./fetchJobs";
import fetchJob from "./fetchJob";
import fetchResults from "./fetchResults";
import downloadResult from "./downloadResult";
import changeJobName from "./changeJobName";
import fetchJobsSpent from "./fetchJobsSpent";
import fetchTasksEarned from "./fetchTasksEarned";
import createJob from "./createJob";
import fetchJobTasksUpdated from "./fetchJobTasksUpdated";
import cancelJob from "./cancelJob";
import { all } from "redux-saga/effects";

export default function* rootSaga(): Generator {
    yield all([
        fetchJobs(),
        fetchJob(),
        fetchResults(),
        downloadResult(),
        changeJobName(),
        fetchJobsSpent(),
        fetchTasksEarned(),
        createJob(),
        fetchJobTasksUpdated(),
        cancelJob(),
    ]);
}
